import { useEffect, useState } from "react";

export default function useTheme() {
  const [dark, setDark] = useState(() => localStorage.getItem("manda_theme") === "dark");

  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("manda_theme", dark ? "dark" : "light");
  }, [dark]);

  return { dark, toggle: () => setDark((d) => !d) };
}
